(function() { window.GUID_f34ac418_d4c3_4969_8371_26bcc04ae8bd = { getGuid: function() { return "f34ac418-d4c3-4969-8371-26bcc04ae8bd"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        /**
         * Helper to bind Dom to the image-cropper
         */
        class ImageCropper extends Controls.ControlBase {
            constructor() {
                super(...arguments);
                this.FromHtmlHelper = true;
            }
            OnBindEvents() {
            }
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$Helper;
            }
            OnDispose() {
                if (this.Params) {
                    if (this.Params.OpenFileButton)
                        this.Params.OpenFileButton.off('click.' + this.ControlId);
                    if (this.Params.WebcamButton)
                        this.Params.WebcamButton.off('click.' + this.ControlId);
                    if (this.Params.FileInput)
                        this.Params.FileInput.off('change.' + this.ControlId);
                }
                if (this.ExtraParams != null) {
                    if (this.ExtraParams.ShowCropperButton) {
                        this.ExtraParams.ShowCropperButton.off('click.' + this.ControlId);
                    }
                }
                this.$Control.remove();
            }
            OnControlInstantiation(params) {
                Controls.ImageCropperAddons.SupportFix.fixRequestAnimationFrame();
                this.$Helper = $('#' + params[0]);
                this.controlId = params[0];
                let me = this;
                me.ImageCropper = new Controls.ImageCropperAddons.ImageCropperPopup(this);
                me.ImageCropperWebcam = new Controls.ImageCropperAddons.ImageCropperWebcam(this);
                if (params.length > 1) {
                    this.FromHtmlHelper = params[1];
                }
                if (this.FromHtmlHelper && this.$Helper.hasClass("image-cropper-helper")) {
                    let param = this.$Helper.data('param');
                    me.$Img = this.$Helper.find('.cropper-img');
                    //let sizeStr = me.$Helper.data('croppingsize');
                    if (param.CroppingSize != null) {
                        me.croppingSize = new CS.Size(param.CroppingSize.Width, param.CroppingSize.Height);
                    }
                    let btnWebCam = me.$Helper.find('.btn-webcam');
                    let btnFile = me.$Helper.find('.btn-file');
                    let fileInput = me.$Helper.find('.file-input');
                    let hiddenInput = me.$Helper.find('.input-hidden');
                    me.register({
                        Container: me.$Helper,
                        ControlId: this.controlId,
                        Image: me.$Img,
                        CroppingSize: me.croppingSize,
                        FileInput: fileInput,
                        HiddenInput: hiddenInput,
                        OpenFileButton: btnFile,
                        WebcamButton: btnWebCam,
                        ImageType: param.ImageType,
                        ImageOverlayUrl: param.ImageOverlayUrl,
                        DisableMinSizeRestriction: param.DisableMinSizeRestriction,
                        SaveOverlay: param.SaveOverlay,
                        SportEventId: param.SportEventId,
                        EntityId: param.EntityId
                    });
                }
            }
            overlayUrl() {
                //Try the $Helper data overlay, then failback to the param
                //Im calling this each time to prevent breaking change if overlay was changed on the data somewhere
                if (this.$Helper != null && this.$Helper.length > 0)
                    return this.$Helper.data('overlaysrc') ? this.$Helper.data('overlaysrc') : this.Params.ImageOverlayUrl;
                return this.Params.ImageOverlayUrl;
            }
            nativeAppPluginAvailable() {
                //Here i assume if the .app.js is loaded, it's our NativeApp so the functions are available.
                if (Controls.ImageCropperAddons && Controls.ImageCropperAddons.NativeAppCommunications)
                    return true;
                return false;
            }
            /**
             * Check if webcam is supported and give a raison if it's not supported
             */
            IsWebcamSupported() {
                if (this.nativeAppPluginAvailable())
                    return { IsSupported: true, IsSupportedByNativeApp: true };
                if (this.isIE())
                    return { IsSupported: false, IsSupportedByNativeApp: false, notSupportedRaison: ImageCropper.WebcamNotSupportedRaison.IE_NOT_SUPPORTED };
                if (CS.Controls.ImageCropperAddons != null && CS.Controls.ImageCropperAddons.ImageCropperWebcam != null)
                    if (Controls.ImageCropperAddons.ImageCropperWebcam.IsSupported())
                        return { IsSupported: true, IsSupportedByNativeApp: false };
                    else
                        return { IsSupported: false, IsSupportedByNativeApp: false, notSupportedRaison: ImageCropper.WebcamNotSupportedRaison.GET_USER_MEDIA_NOT_PRESENT };
                else
                    return { IsSupported: false, IsSupportedByNativeApp: false, notSupportedRaison: ImageCropper.WebcamNotSupportedRaison.PLUGIN_NOT_LOADED };
            }
            isIE() {
                return window.navigator.userAgent.match(/(MSIE|Trident)/);
            }
            static fixIImageCropperHelperParamsImageTypeEnum(param) {
                if (param && param.ImageType != null && typeof param.ImageType === 'number') //if it's a number, it meen it's the ImageHistoryType.Name used. We need string.
                    param.ImageType = ImageCropper.ImageHistoryTypeEnum[param.ImageType];
            }
            register(param, extraParam) {
                var _a;
                var me = this;
                ImageCropper.fixIImageCropperHelperParamsImageTypeEnum(param);
                me.Params = param;
                me.ImageCropper.MinSizeRestrictionEnabled = me.Params.DisableMinSizeRestriction !== true;
                me.ExtraParams = extraParam;
                me.$Img = me.Params.Image;
                me.IsValid = ((_a = me.$Img.data('valid')) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == "true";
                me.ImgHtml = me.Params.Image[0];
                me.croppingSize = new CS.Size(me.Params.CroppingSize.Width, me.Params.CroppingSize.Height);
                me.onImageCropped = me.Params.onImageCropped;
                if (me.croppingSize == null && me.Params.ImageOverlayUrl == null && (me.$Helper == null || !me.$Helper.data('overlaysrc'))) {
                    let imageType;
                    if (typeof me.Params.ImageType === "string") {
                        imageType = CS.Entity.General.ImageHistoryTypeEnum[me.Params.ImageType];
                    }
                    else {
                        imageType = me.Params.ImageType;
                    }
                    if (me.croppingSize == null) {
                        console.error("Image cropper must have CroppingSize or ImageOverlayUrl defined. ControlId: " + param.ControlId);
                    }
                }
                if (me.Params.Container != null && me.Params.Container.hasClass('image-cropper-helper')) {
                    me.Params.Container.data(ImageCropper.dataInstanceKey, this);
                }
                let fromHelper = false;
                me.ImgHtml = me.$Img[0];
                if (me.Params.OpenFileButton != null)
                    me.Params.OpenFileButton.offon('click.' + this.ControlId, function () {
                        me.OpenFile();
                    });
                if (me.Params.WebcamButton != null) {
                    if (this.checkWebcamSupport())
                        me.Params.WebcamButton.offon('click.' + this.ControlId, function () {
                            fromHelper = true;
                            me.OpenWebcam();
                        });
                }
                CS.Helper.log('ImageCropper', 'image-cropper register');
                if (extraParam != null) {
                    if (me.ExtraParams.ShowCropperButton != null) {
                        me.ExtraParams.ShowCropperButton.offon('click.' + this.ControlId, function (e) {
                            e.stopPropagation(); // Need to stop propagation when clicking on camera icon overlaping image
                            me.Show();
                        });
                    }
                }
                if (me.Params.FileInput != null)
                    me.Params.FileInput.offon('change.' + this.ControlId, function () {
                        if (me.Params.FileInput.val() != "") {
                            let fileInputHtml = me.Params.FileInput[0];
                            let url = window.URL.createObjectURL(fileInputHtml.files[0]);
                            me.showCropper(url);
                        }
                    });
            }
            checkWebcamSupport() {
                var me = this;
                var supported = me.IsWebcamSupported();
                if (supported.IsSupported == false) {
                    //IE 11 and below dont support webcam unless we failback to flash (NO)
                    if (me.Params.onWebcamNotSupported == null) {
                        var wIcon = $('i', me.Params.WebcamButton);
                        if (wIcon.length == 0)
                            me.Params.WebcamButton.html("<i class='icon ic-cs-btnconflicts'></i>&nbsp;" + me.Params.WebcamButton.text());
                        else
                            wIcon.attr('class', "icon ic-cs-btnconflicts");
                        me.Params.WebcamButton.addClass('not-supported');
                        if (supported.notSupportedRaison == ImageCropper.WebcamNotSupportedRaison.IE_NOT_SUPPORTED)
                            me.Params.WebcamButton.attr('title', ImageCropper.Ress.WebcamNotSupported_IE());
                        else
                            me.Params.WebcamButton.attr('title', ImageCropper.Ress.WebcamNotSupported());
                    }
                    else
                        me.Params.onWebcamNotSupported(supported.notSupportedRaison, me.Params.WebcamButton, me);
                    me.Trigger(ImageCropper.EventNames.WebcamNotSupported, { jqueryEventObject: null, data: { raison: supported.notSupportedRaison, WebcamButton: me.Params.WebcamButton, sender: me } });
                    return false;
                }
                return true;
            }
            /**
             * Open the OpenFile browser Dialog folowed by the cropping dialog.
             */
            OpenFile() {
                var me = this;
                //Check if the native app plugin is available
                if (me.nativeAppPluginAvailable()) {
                    CS.NativeApp.NA_ShowNativeDebugInfo("Native Image Cropper - OpenFileClicked");
                    //Call the native app Api
                    Controls.ImageCropperAddons.NativeAppCommunications.SelectPicture(me.ControlId, (base64Image) => me.showCropper(base64Image));
                }
                else {
                    me.Params.FileInput.val(null);
                    me.Params.FileInput.trigger('click');
                }
            }
            /**
             * Open the WebCam image picker Dialog.
             */
            OpenWebcam() {
                var me = this;
                //Check if the native app plugin is available
                if (me.nativeAppPluginAvailable()) {
                    CS.NativeApp.NA_ShowNativeDebugInfo("Natime Image Cropper - WebcamClicked");
                    //Call the native app Api
                    Controls.ImageCropperAddons.NativeAppCommunications.TakePhoto(me.ControlId, (base64Image) => me.showCropper(base64Image));
                }
                else {
                    //If its created by the HtmlHelper on Mvc, $Helper contains an element, else use params
                    let overlayUrl = me.overlayUrl();
                    let callback = (url) => {
                        this.triggerPopupVisibilityChanged({ popup: ImageCropper.PopupType.WebCam, visible: false });
                        me.showCropper(url);
                    };
                    this.triggerPopupVisibilityChanged({ popup: ImageCropper.PopupType.WebCam, visible: true });
                    if (overlayUrl != null && overlayUrl != "")
                        me.ImageCropperWebcam.Show(overlayUrl, callback);
                    else
                        me.ImageCropperWebcam.ShowWithoutOverlay(me.croppingSize, callback);
                }
            }
            Show() {
                this.showCropper(this.Params.Image.attr("src"));
            }
            showCropper(url) {
                let me = this;
                this.triggerPopupVisibilityChanged({ popup: ImageCropper.PopupType.Cropper, visible: true });
                this.ImageCropper.Show(url, me.overlayUrl(), function ImageCropperCallback(result) {
                    me.triggerPopupVisibilityChanged({ popup: ImageCropper.PopupType.Cropper, visible: false });
                    me.ImgHtml.src = result.Url;
                    me.Trigger(ImageCropper.EventNames.ImageCropped, { jqueryEventObject: null, data: result });
                    if (me.Params.HiddenInput != null && me.Params.HiddenInput.length > 0)
                        me.Params.HiddenInput.val(result.Url);
                    if (me.onImageCropped != null)
                        me.onImageCropped(result, me);
                }, me.croppingSize);
            }
            /**
             * Wrap the helper arround an existing image. The image or the Container must be allredy added to DOM.
             * @param param
             * Creation params. All optionals elements will be created and appended to the dom if not specified. You can specify elements that are allreddy added to the dom, in this case the element will not be append to the dom.
             * @param createButtonIfNotExist
             * Set it to false to prevent the creation of 'File' and 'Webcam' button. You will have to trigger the OpenFile() and OpenWebcam() yourself (check IsWebcamSupported() ).
             */
            static WrapImage(param, createButtonIfNotExist = true) {
                ImageCropper.fixIImageCropperHelperParamsImageTypeEnum(param);
                if (param.Container == null || param.Container.length == 0)
                    param.Container = $('<div></div>').attr({
                        id: param.ControlId,
                        class: "image-cropper-helper"
                    });
                if (param.HiddenInput == null || param.HiddenInput.length == 0)
                    param.HiddenInput = $('<input />').attr({
                        class: "input-hidden",
                        type: "hidden",
                        name: param.ControlId
                    });
                if (createButtonIfNotExist && (param.OpenFileButton == null || param.OpenFileButton.length == 0))
                    param.OpenFileButton = ImageCropper.Defaults.fileButton();
                if (createButtonIfNotExist && (param.WebcamButton == null || param.WebcamButton.length == 0))
                    param.WebcamButton = ImageCropper.Defaults.webCamButton();
                if (param.FileInput == null || param.FileInput.length == 0)
                    param.FileInput = $('<input />')
                        .attr({
                        class: "file-input",
                        type: "file",
                        accept: "image/png, image/jpeg, image/gif, image/bmp"
                    });
                if (!document.body.contains(param.Container[0])) {
                    //Container is not in document
                    if (document.body.contains(param.Image[0])) {
                        //Image is on dom, so wrap the container arround it
                        param.Image.wrap(param.Container);
                        param.Container = param.Image.closest(param.Container[0].tagName);
                    }
                }
                else {
                    //Container is in document
                    if (document.body.contains(param.Image[0])) {
                        //Image is not on dom, so add it to the container
                        param.Container.append(param.Image);
                    }
                }
                if (!document.body.contains(param.HiddenInput[0])) {
                    param.Container.append(param.HiddenInput);
                }
                if (param.OpenFileButton != null && !document.body.contains(param.OpenFileButton[0])) {
                    param.Container.append(param.OpenFileButton);
                }
                if (param.WebcamButton != null && !document.body.contains(param.WebcamButton[0])) {
                    param.Container.append(param.WebcamButton);
                }
                if (!document.body.contains(param.FileInput[0])) {
                    param.Container.append(param.FileInput);
                }
                return this.Create(param);
            }
            /**
             * Bind the Image Cropper to the image. No controls will be created or added to the dom except FileInput.
             * @param param
             */
            static Create(param, extraParam) {
                ImageCropper.fixIImageCropperHelperParamsImageTypeEnum(param);
                if ($(`#${param.ControlId}`).length == 0 && param.Container != null)
                    param.Container.attr('id', param.ControlId);
                let instance = new ImageCropper(param.ControlId);
                if (param.FileInput == null || param.FileInput.length == 0) {
                    param.FileInput = $('<input />')
                        .attr({
                        class: "file-input hidden",
                        type: "file",
                        accept: "image/png, image/jpeg, image/gif, image/bmp"
                    });
                    param.Image.after(param.FileInput);
                }
                instance.register(param, extraParam);
                return instance;
            }
            /**
             * Get the instance of controls created using the @Html.ImageCropper MVC HtmlHelper
             * @param ControlId
             * The id of the container : <div class="image-cropper-helper">
             */
            static GetHelper(ControlId) {
                var container = $('#' + ControlId);
                if (container != null && container.length > 0)
                    return container.data(ImageCropper.dataInstanceKey);
                return null;
            }
            triggerPopupVisibilityChanged(arg) {
                this.Trigger(ImageCropper.EventNames.PopupVisibilityChange, { data: arg, jqueryEventObject: null });
            }
        }
        ImageCropper.Ress = {
            WebcamNotSupported_IE: () => {
                return CS.Lang("Internet explorer doesn't support webcam. Please use a modern browser.", "Internet Explorer ne supporte pas la webcam. Veuillez utiliser un navigateur plus récent.");
            },
            WebcamNotSupported: () => {
                return CS.Lang("Your browser doesn't support webcam. Please use a modern browser.", "Votre navigateur ne supporte pas la webcam. Veuillez utiliser un navigateur plus récent.");
            },
            File: () => {
                return CS.Lang("File", "Fichier");
            },
            Save: () => {
                return CS.Lang("Save", "Sauvegarder");
            },
            TakePicture: () => {
                return CS.Lang("Take picture", "Prendre une photo");
            }
        };
        ImageCropper.Defaults = {
            fileButton: () => {
                return $('<button></button>')
                    .attr({
                    type: "button",
                    class: "button button--big btn-file"
                })
                    .text(ImageCropper.Ress.File());
            },
            webCamButton: () => {
                return $('<button></button>')
                    .attr({
                    type: "button",
                    class: "button button--big btn-webcam"
                })
                    .text('Webcam');
            }
        };
        ImageCropper.dataInstanceKey = "image-cropper-instance";
        Controls.ImageCropper = ImageCropper;
        (function (ImageCropper) {
            class Events {
                static WebcamNotSupported(param) {
                    Controls.RegisterEvent(ImageCropper, EventNames.WebcamNotSupported, param);
                }
                static ImageCropped(param) {
                    Controls.RegisterEvent(ImageCropper, EventNames.ImageCropped, param);
                }
                static PopupVisibilityChange(param) {
                    Controls.RegisterEvent(ImageCropper, EventNames.PopupVisibilityChange, param);
                }
            }
            ImageCropper.Events = Events;
            class EventNames {
            }
            EventNames.WebcamNotSupported = "webcam-not-supported";
            EventNames.ImageCropped = "image-cropped";
            EventNames.PopupVisibilityChange = "image-cropper-visibility-changed";
            ImageCropper.EventNames = EventNames;
            let PopupType;
            (function (PopupType) {
                PopupType[PopupType["Cropper"] = 0] = "Cropper";
                PopupType[PopupType["WebCam"] = 1] = "WebCam";
            })(PopupType = ImageCropper.PopupType || (ImageCropper.PopupType = {}));
            let WebcamNotSupportedRaison;
            (function (WebcamNotSupportedRaison) {
                WebcamNotSupportedRaison[WebcamNotSupportedRaison["IE_NOT_SUPPORTED"] = 0] = "IE_NOT_SUPPORTED";
                WebcamNotSupportedRaison[WebcamNotSupportedRaison["GET_USER_MEDIA_NOT_PRESENT"] = 1] = "GET_USER_MEDIA_NOT_PRESENT";
                WebcamNotSupportedRaison[WebcamNotSupportedRaison["PLUGIN_NOT_LOADED"] = 2] = "PLUGIN_NOT_LOADED";
            })(WebcamNotSupportedRaison = ImageCropper.WebcamNotSupportedRaison || (ImageCropper.WebcamNotSupportedRaison = {}));
            ImageCropper.ImageHistoryTypeEnum = CS.Entity.General.ImageHistoryTypeEnum;
        })(ImageCropper = Controls.ImageCropper || (Controls.ImageCropper = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=image-cropper.js.map
